import React, { useState, useEffect } from "react";
import styles from "./styles.module.css";
import NoSSR from "@components/utils/NoSSR";
import Rub from "../icons/ruble";
import cx from "classnames";
import OrderForm from "../orderForm";
import Tinkoff from "./icons/tinkoff.png";
import Usdt from "./icons/usdt";
import Etherium from "./icons/etherium";

const PriceList = ({ priceOld, logo, title, promocodes }) => {
  const [price, setPrice] = useState(
    parseFloat(priceOld.replace(/[^0-9\.]+/g, ""))
  );
  const [priceETH, setPriceETH] = useState(1.47);
  const [priceUSDT, setPriceUSDT] = useState(2400);

  function numberWithSpaces(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return parts.join(".");
  }
  return (
    <>
      <NoSSR>
        <div className={styles.root}>
          <div className={styles.leftInfo}>
            <div className={styles.container}>
              <div className={styles.tinkoffPrice}>
                <div className={styles.priceContainer}>
                  <img
                    className={styles.tinkoff}
                    width={36}
                    height={36}
                    src={Tinkoff}
                  />
                  <span className={styles.creditPrice} key="value">
                    {numberWithSpaces(price)}
                  </span>
                  <span
                    className={cx(styles.rouble, styles.roubleForCredit)}
                    key="currency-24"
                  >
                    <Rub />
                    <span className={styles.newPrice}>/&thinsp;мес</span>
                  </span>
                </div>
                <p className={styles.textForCredit}>
                  В рассрочку на 24 месяца.
                  <br />
                  Без процентов и
                  <span style={{ whiteSpace: "nowrap" }}>&nbsp;</span>
                  переплат.
                </p>
              </div>
              <div className={styles.etherPrice}>
                <div className={styles.separator}>или</div>
                <div className={styles.priceContainer}>
                  <Etherium className={styles.tinkoff} />
                  <span className={styles.creditPrice} key="value">
                    {priceETH} ETH
                  </span>
                </div>
                <p className={styles.textForCredit}>
                  Единовременный донат.
                  <br />
                  Деньги пойдут в казну DAO.
                </p>
              </div>

              <div className={styles.usdtPrice}>
                <div className={styles.separator}>или</div>
                <div className={styles.priceContainer}>
                  <Usdt className={styles.tinkoff} />
                  <span className={styles.creditPrice} key="value">
                    {numberWithSpaces(priceUSDT)} USDT
                  </span>
                </div>
                <p className={styles.textForCredit}>
                  Единовременный донат.
                  <br />
                  Деньги пойдут в казну DAO.
                </p>
              </div>
            </div>

            <div className={styles.triangle}></div>
          </div>

          <div className={styles.rightForm}>
            <OrderForm
              promocodes={promocodes}
              logo={logo}
              title={title}
              price={price}
              priceETH={priceETH}
              priceUSDT={priceUSDT}
              setPrice={setPrice}
              setPriceETH={setPriceETH}
              setPriceUSDT={setPriceUSDT}
            />
          </div>
        </div>
      </NoSSR>
    </>
  );
};

export default PriceList;
